Ext.define('SA.view.mapexport.AddTextLabelWindow', {
    alias: 'widget.export-add-text-label-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-export-add-text-label-window',
    includeCancelBtn: true,
    includeOkBtn: true,
    okAction: 'onOkClick',
    title: 'Add Text Label',

    initComponent() {
        this.callParent();

        this.field = this.down('#field');
    },

    afterRender() {
        this.callParent();

        this.field.focus();
    },

    getBodyItems() {
        return {
            xtype: 'sa-textfield',
            cls: 'sa-export-add-text-label-window-field-input',
            height: 35,
            itemId: 'field'
        };
    },

    onOkClick() {
        var text = this.field.getValue();

        Ext.callback(this.handler, this.scope || this, [text]);

        this.destroy();
    }
});
